import {makeStyles} from '@material-ui/styles'

const useStyles = makeStyles({
  list: {
    width: 400,
  },
  fullList: {
    width: 'auto',
  },
  buttonLink: {
    marginTop: 15,
    marginRight: 15,
    textTransform: 'none',
  },
  borderStyle: {
    border: '1px solid',
    borderColor: '#e0e0e0',
  },
  radioSpacing: {
    marginLeft: 5,
  },
  backBtn: {
    marginLeft: 15,
    textTransform: 'none',
    marginTop: 15,
    color: '#9e9e9e',
  },
})

export default useStyles
